import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=56942f25&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=56942f25&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56942f25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56942f25')) {
      api.createRecord('56942f25', component.options)
    } else {
      api.reload('56942f25', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=56942f25&scoped=true", function () {
      api.rerender('56942f25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/receptionSystem/roomManagement/roomManage/detail.vue"
export default component.exports